import r2wc from '@r2wc/react-to-web-component';
import '@webcomponents/custom-elements';
import ProductIBEWidget from '../widgets/ProductIBEWidget';

const WebProductIBEWidget = r2wc(ProductIBEWidget, {
  props: {
    thgConfig: 'json',
    configOverrides: 'json',
    packageCodes: 'json',
    earliestPossibleDate: 'string',
    latestPossibleDate: 'string',
    numberOfTravelers: 'number',
    seasonBestPriceDate: 'string',
    seasonBestPricePackageCode: 'string',
    checkoutUrl: 'string',
    maintenanceMode: 'boolean',
    agencyNumber: 'string',
    isWhitelabel: 'boolean',
    mode: 'string',
    triggerSearch: 'boolean',
    widgetSessionKeyPrefix: 'string',
    origin: 'json',
    origins: 'json',
    destination: 'json',
    destinations: 'json',
    startDate: 'string',
    endDate: 'string',
    occupancy: 'json',
    directFlightsOnly: 'boolean',
    packageServiceGroup: 'string',
    subType: 'json',
    dateInputType: 'json',
    duration: 'number',
    packageCode: 'string',
    salesChannel: 'string',
    mainServiceCodes: 'json',
    preSelectedCharacteristics: 'json',
    inventories: 'json',
    productId: 'string',
    destinationItem: 'json',
    goToDetails: 'boolean',
    isFromSearchButton: 'boolean',
    listOptions: 'json',
    postalCode: 'string',
    basePrice: 'string',
    suppressStrikePrices: 'boolean'
  }
});

customElements.get('thg-product-ibe') ||
  customElements.define('thg-product-ibe', WebProductIBEWidget);
